export const WIEDERVORLAGEN_RUNTIME_MODULE = "Wiedervorlagen";

export const WIEDERVORLAGEN_OVERVIEW_ACTIVITY = "WIEDERVORLAGEN_OVERVIEW_ACTIVITY";

export const PATHS = {
	Erledigt: "/root/Erledigt",
	ProcessId: "/root/ProcessId",
	Faelligkeitsdatum: "/root/Faelligkeitsdatum",
	Assignee: {
		id: "/root/assignee/id",
		firstName: "/root/assignee/firstName",
		lastName: "/root/assignee/lastName"
	}
};
